// import React, { useState } from 'react';
// import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     surname: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert('Formularz został wysłany!');
//   };

//   return (
//     <section className="py-16 bg-[#edece8] relative">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2 className="text-4xl font-bold text-yellow-600 text-left mb-8 md:mb-12 lg:mb-12 pr-4">Zapraszamy</h2>
        
//         <div className="grid md:grid-cols-2 gap-8">
//           {/* Left Section: Kontakt Info - ZAKTUALIZOWANE */}
//           <div className="flex flex-col justify-center">
//             <h2 className="text-3xl font-semibold mb-8 text-gray-800">Kontakt</h2>
//             <div className="space-y-6">
//               {/* Adres Kolorowe Domki */}
//               <div className="flex items-start">
//                 <FaMapMarkerAlt className="text-yellow-500 text-2xl mt-1 mr-4 flex-shrink-0" />
//                 <div>
//                   <h3 className="text-xl font-bold text-gray-800 mb-1">Kolorowe Domki</h3>
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     ul. Wiatrakowa 30<br />
//                     84-104 Jastrzębia Góra
//                   </p>
//                 </div>
//               </div>

//               {/* Adres Apartamenty Kolorowe Domki DeLuxe */}
//               <div className="flex items-start">
//                 <FaMapMarkerAlt className="text-yellow-500 text-2xl mt-1 mr-4 flex-shrink-0" />
//                 <div>
//                   <h3 className="text-xl font-bold text-gray-800 mb-1">Apartamenty</h3>
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     ul. Rydzowa 1<br />
//                     84-104 Jastrzębia Góra - Tupadły
//                   </p>
//                 </div>
//               </div>

//               {/* Telefon */}
//               <div className="flex items-center">
//                 <FaPhoneAlt className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Telefon:</span> +48 608 025 978
//                 </p>
//               </div>

//               {/* Email */}
//               <div className="flex items-center">
//                 <FaEnvelope className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Email:</span>{' '}
//                   <a href="mailto:kontakt@kolorowedomki.com" className="text-yellow-600 hover:underline">
//                     kontakt@kolorowedomki.com
//                   </a>
//                 </p>
//               </div>

//               {/* Godziny pracy */}

//               {/*
//               <div className="bg-yellow-50 p-4 rounded-lg mt-4">
//   <div className="flex items-center">
//     <FaClock className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//     <p className="text-lg text-gray-800 font-medium">
//       Godziny pracy: <span className="text-yellow-600">Pon-Pt: 9:00 - 18:00</span>
//     </p>
//   </div>
// </div>
//               */}
//               <div className="flex items-center">
//                 <FaClock className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Godziny pracy:</span> Pon-Pt: 9:00 - 18:00
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Right Section: Contact Form */}
//           <div className="flex flex-col justify-center bg-white p-8 rounded-lg shadow-lg">
//             <h3 className="text-2xl font-semibold mb-4">Wyślij zapytanie</h3>
//             <form onSubmit={handleSubmit}>
//               {/* Imię i Nazwisko */}
//               <div className="mb-4 flex space-x-4">
//                 <div className="w-1/2">
//                   <label htmlFor="name" className="block text-sm font-medium text-gray-700">Imię</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                     placeholder="Wpisz swoje imię"
//                   />
//                 </div>
//                 <div className="w-1/2">
//                   <label htmlFor="surname" className="block text-sm font-medium text-gray-700">Nazwisko</label>
//                   <input
//                     type="text"
//                     id="surname"
//                     name="surname"
//                     value={formData.surname}
//                     onChange={handleChange}
//                     className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                     placeholder="Wpisz swoje nazwisko"
//                   />
//                 </div>
//               </div>

//               {/* Adres Email */}
//               <div className="mb-4">
//                 <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Wpisz swój email"
//                 />
//               </div>

//               {/* Telefon */}
//               <div className="mb-4">
//                 <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Telefon</label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Wpisz swój numer telefonu"
//                 />
//               </div>

//               {/* Wiadomość */}
//               <div className="mb-6">
//                 <label htmlFor="message" className="block text-sm font-medium text-gray-700">Wiadomość</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows="4"
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Napisz swoją wiadomość"
//                 />
//               </div>
//               <div className="mb-6 flex items-start">
//                  <input type="checkbox" id="consent" name="consent" required className="mt-1 mr-2" />
//                   <label htmlFor="consent" className="text-sm text-gray-700">
//                      Wypełniając formularz i klikając przycisk „Wyślij", wyrażasz zgodę na przesłanie Twojego zapytania, w tym Twoich danych osobowych. AdministrTwoich danych osobowych jest               <strong>NAZWA FIRMY, ADRES, NIP</strong>. Szczegóły w jaki sposób przetwarzamy Twoje dane oraz jakiprawa z tym związane znajdziesz w naszej <a href="/polityka-prywatnosci" className="text-yellow-600 undhover:text-yellow-700">Polityce Prywatności</a>.
//                   </label>
//                 </div>
//               <button
//                 type="submit"
//                 className="w-full bg-yellow-500 text-white py-3 rounded-full hover:bg-yellow-600 transition duration-300"
//               >
//                 Wyślij
//               </button>
//             </form>
//           </div>
//         </div>
      
//       <div className="mt-12 px-4">
//           {/* Duży napis przed mapami */}
//           <h2 className="text-3xl font-semibold mb-4">Gdzie nas znajdziesz</h2>
//       {/* Mapy obok siebie */}
//       <div className="mt-12 px-4 flex flex-col lg:flex-row lg:justify-center lg:space-x-0 space-y-12 lg:space-y-0">
//         {/* Mapa: Kolorowe Domki */}
//         <div className="flex-1 flex flex-col items-center">
//           <h3 className="text-xl font-semibold mb-4 text-yellow-600">Mapa: Kolorowe Domki</h3>
//           <div className="w-full max-w-[398px] aspect-[398/678]">
//             <iframe
//               title="Mapa Kolorowe Domki"
//               className="w-full h-full"
//               style={{ border: 0 }}
//               loading="lazy"
//               allowFullScreen
//               src="https://www.google.pl/maps/place/Kolorowe+Domki+Jastrz%C4%99bia+G%C3%B3ra/@54.8267214,18.3217428,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b29b9b7bebb:0x5b107c7de8090dc!8m2!3d54.8267183!4d18.3243177!16s%2Fg%2F11kpzwbdzd?entry=tt"
//             ></iframe>
//           </div>
//         </div>

//         {/* Mapa: Apartamenty Kolorowe Domki DeLuxe */}
//         <div className="flex-1 flex flex-col items-center">
//           <h3 className="text-xl font-semibold mb-4 text-yellow-600">Mapa: Apartamenty Kolorowe Domki</h3>
//           <div className="w-full max-w-[398px] aspect-[398/678]">
//             <iframe
//               title="Mapa Apartamenty DeLuxe"
//               className="w-full h-full"
//               style={{ border: 0 }}
//               loading="lazy"
//               allowFullScreen
//               src="https://www.google.pl/maps/place/Apartamenty+Kolorowe+Domki/@54.825977,18.321132,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b3498a3f99f:0xce86cb90a9dfbc7a!8m2!3d54.8259739!4d18.3237069!16s%2Fg%2F11fprzqp29?entry=ttu"

//             /* Aby dodać pinezkę nalezy: 
//             Krok 1: Utwórz konto Google Cloud
// Wejdź na stronę Google Cloud Console.

// Jeśli jeszcze nie masz konta Google Cloud, będziesz musiał się zarejestrować lub zalogować za pomocą swojego konta Google.

// Krok 2: Utwórz projekt
// Po zalogowaniu się na stronie Google Cloud, kliknij "Select a project" (Wybierz projekt) lub "New Project" (Nowy projekt).

// Wybierz nazwę projektu i kliknij "Create" (Utwórz).

// Krok 3: Włącz Google Maps API
// W menu po lewej stronie kliknij na "APIs & Services" (API i usługi) -> "Library" (Biblioteka).

// Wyszukaj "Maps JavaScript API" i kliknij na nią, a następnie kliknij "Enable" (Włącz).

// Następnie przejdź do "Geocoding API" oraz "Places API", i także je włącz.

// Krok 4: Utwórz klucz API
// W menu po lewej stronie kliknij "APIs & Services" (API i usługi) -> "Credentials" (Poświadczenia).

// Kliknij "Create Credentials" (Utwórz poświadczenia), a następnie wybierz "API Key" (Klucz API).

// Twój klucz API pojawi się w oknie, skopiuj go.

// Krok 5: Ochrona klucza API
// Aby chronić swój klucz API, możesz ustawić ograniczenia, takie jak:

// Ograniczenie do określonych adresów IP – jeśli aplikacja jest hostowana na określonym serwerze.

// Ograniczenie do określonych refererów HTTP – jeśli używasz API w aplikacji webowej.

// Ograniczenie do określonych API – tylko dla wybranych API, takich jak Maps JavaScript API.
// */
             
//             ></iframe>
//           </div>
//         </div>
//       </div>
//       </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;


// import React, { useState } from 'react';
// import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     surname: '',
//     email: '',
//     phone: '',
//     message: '',
//     consent: false
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setSubmitStatus(null);


//     // Zmień URL w fetch na Twój rzeczywisty adres
//     //Dodaj NIP w tekście zgody
//     //Umieść plik PHP na serwerze (jak w poprzedniej instrukcj
//     //Zmień adres email w pliku PHP na kontakt@kolorowedomki.com
//     try {
//       const response = await fetch('https://kolorowedomki.com/send-email.php', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (result.success) {
//         setSubmitStatus({ type: 'success', message: 'Formularz został wysłany pomyślnie!' });
//         // Reset form
//         setFormData({
//           name: '',
//           surname: '',
//           email: '',
//           phone: '',
//           message: '',
//           consent: false
//         });
//       } else {
//         setSubmitStatus({ type: 'error', message: result.message || 'Wystąpił błąd podczas wysyłania formularza' });
//       }

//     } catch (error) {
//       setSubmitStatus({ type: 'error', message: 'Wystąpił błąd połączenia. Spróbuj ponownie.' });
//       console.error('Error:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <section className="py-16 bg-[#edece8] relative">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2 className="text-4xl font-bold text-yellow-600 text-left mb-8 md:mb-12 lg:mb-12 pr-4">Zapraszamy</h2>
        
//         <div className="grid md:grid-cols-2 gap-8">
//           {/* Left Section: Kontakt Info */}
//           <div className="flex flex-col justify-center">
//             <h2 className="text-3xl font-semibold mb-8 text-gray-800">Kontakt</h2>
//             <div className="space-y-6">
//               {/* Adres Kolorowe Domki */}
//               <div className="flex items-start">
//                 <FaMapMarkerAlt className="text-yellow-500 text-2xl mt-1 mr-4 flex-shrink-0" />
//                 <div>
//                   <h3 className="text-xl font-bold text-gray-800 mb-1">Kolorowe Domki</h3>
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     ul. Wiatrakowa 30<br />
//                     84-104 Jastrzębia Góra
//                   </p>
//                 </div>
//               </div>

//               {/* Adres Apartamenty Kolorowe Domki DeLuxe */}
//               <div className="flex items-start">
//                 <FaMapMarkerAlt className="text-yellow-500 text-2xl mt-1 mr-4 flex-shrink-0" />
//                 <div>
//                   <h3 className="text-xl font-bold text-gray-800 mb-1">Apartamenty</h3>
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     ul. Rydzowa 1<br />
//                     84-104 Jastrzębia Góra - Tupadły
//                   </p>
//                 </div>
//               </div>

//               {/* Telefon */}
//               <div className="flex items-center">
//                 <FaPhoneAlt className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Telefon:</span> +48 608 025 978
//                 </p>
//               </div>

//               {/* Email */}
//               <div className="flex items-center">
//                 <FaEnvelope className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Email:</span>{' '}
//                   <a href="mailto:kontakt@kolorowedomki.com" className="text-yellow-600 hover:underline">
//                     kontakt@kolorowedomki.com
//                   </a>
//                 </p>
//               </div>

//               {/* Godziny pracy */}
//               <div className="flex items-center">
//                 <FaClock className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
//                 <p className="text-lg text-gray-700">
//                   <span className="font-semibold">Godziny pracy:</span> Pon-Pt: 9:00 - 18:00
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Right Section: Contact Form */}
//           <div className="flex flex-col justify-center bg-white p-8 rounded-lg shadow-lg">
//             <h3 className="text-2xl font-semibold mb-4">Wyślij zapytanie</h3>
            
//             {/* Status message */}
//             {submitStatus && (
//               <div className={`mb-4 p-3 rounded-lg ${
//                 submitStatus.type === 'success' 
//                   ? 'bg-green-100 text-green-800 border border-green-200' 
//                   : 'bg-red-100 text-red-800 border border-red-200'
//               }`}>
//                 {submitStatus.message}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>
//               {/* Imię i Nazwisko */}
//               <div className="mb-4 flex space-x-4">
//                 <div className="w-1/2">
//                   <label htmlFor="name" className="block text-sm font-medium text-gray-700">Imię *</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                     placeholder="Wpisz swoje imię"
//                     required
//                   />
//                 </div>
//                 <div className="w-1/2">
//                   <label htmlFor="surname" className="block text-sm font-medium text-gray-700">Nazwisko</label>
//                   <input
//                     type="text"
//                     id="surname"
//                     name="surname"
//                     value={formData.surname}
//                     onChange={handleChange}
//                     className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                     placeholder="Wpisz swoje nazwisko"
//                   />
//                 </div>
//               </div>

//               {/* Adres Email */}
//               <div className="mb-4">
//                 <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email *</label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Wpisz swój email"
//                   required
//                 />
//               </div>

//               {/* Telefon */}
//               <div className="mb-4">
//                 <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Telefon</label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Wpisz swój numer telefonu"
//                 />
//               </div>

//               {/* Wiadomość */}
//               <div className="mb-6">
//                 <label htmlFor="message" className="block text-sm font-medium text-gray-700">Wiadomość *</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows="4"
//                   className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
//                   placeholder="Napisz swoją wiadomość"
//                   required
//                 />
//               </div>

//               {/* Zgoda */}
//               <div className="mb-6 flex items-start">
//                 <input 
//                   type="checkbox" 
//                   id="consent" 
//                   name="consent" 
//                   checked={formData.consent}
//                   onChange={handleChange}
//                   required 
//                   className="mt-1 mr-2" 
//                 />
//                 <label htmlFor="consent" className="text-sm text-gray-700">
//                   Wypełniając formularz i klikając przycisk „Wyślij", wyrażasz zgodę na przesłanie Twojego zapytania, w tym Twoich danych osobowych. Administratorem Twoich danych osobowych jest <strong>Kolorowe Domki, ul. Wiatrakowa 30, 84-104 Jastrzębia Góra, NIP: [TUTAJ WSTAW NIP]</strong>. Szczegóły w jaki sposób przetwarzamy Twoje dane oraz jakie prawa z tym związane znajdziesz w naszej <a href="/polityka-prywatnosci" className="text-yellow-600 hover:text-yellow-700 underline">Polityce Prywatności</a>.
//                 </label>
//               </div>

//               <button
//                 type="submit"
//                 disabled={isLoading}
//                 className="w-full bg-yellow-500 text-white py-3 rounded-full hover:bg-yellow-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-300 flex items-center justify-center"
//               >
//                 {isLoading ? (
//                   <>
//                     <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Wysyłanie...
//                   </>
//                 ) : (
//                   'Wyślij'
//                 )}
//               </button>
//             </form>
//           </div>
//         </div>
//       {/* Mapy powinny wieswietlać się poprawnie po umieszczenniu strony na serwerze z szyfrowaniem */}
//         <div className="mt-12 px-4">
//           <h2 className="text-3xl font-semibold mb-4">Gdzie nas znajdziesz</h2>
          
//           {/* Mapy obok siebie */}
//           <div className="mt-12 px-4 flex flex-col lg:flex-row lg:justify-center lg:space-x-8 space-y-12 lg:space-y-0">
//             {/* Mapa: Kolorowe Domki */}
//             <div className="flex-1 flex flex-col items-center">
//               <h3 className="text-xl font-semibold mb-4 text-yellow-600">Mapa: Kolorowe Domki</h3>
//               <div className="w-full max-w-[398px] aspect-[398/678]">
//                 <iframe
//                   title="Mapa Kolorowe Domki"
//                   className="w-full h-full rounded-lg shadow-md"
//                   style={{ border: 0 }}
//                   loading="lazy"
//                   allowFullScreen
//                   src="https://www.google.pl/maps/place/Kolorowe+Domki+Jastrz%C4%99bia+G%C3%B3ra/@54.8267214,18.3217428,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b29b9b7bebb:0x5b107c7de8090dc!8m2!3d54.8267183!4d18.3243177!16s%2Fg%2F11kpzwbdzd?entry=tt"
//                 ></iframe>
//               </div>
//             </div>

//             {/* Mapa: Apartamenty Kolorowe Domki DeLuxe */}
//             <div className="flex-1 flex flex-col items-center">
//               <h3 className="text-xl font-semibold mb-4 text-yellow-600">Mapa: Apartamenty Kolorowe Domki</h3>
//               <div className="w-full max-w-[398px] aspect-[398/678]">
//                 <iframe
//                   title="Mapa Apartamenty DeLuxe"
//                   className="w-full h-full rounded-lg shadow-md"
//                   style={{ border: 0 }}
//                   loading="lazy"
//                   allowFullScreen
//                   src="https://www.google.pl/maps/place/Apartamenty+Kolorowe+Domki/@54.825977,18.321132,17z/data=!3m1!4b1!4m6!3m5!1s0x46fc4b3498a3f99f:0xce86cb90a9dfbc7a!8m2!3d54.8259739!4d18.3237069!16s%2Fg%2F11fprzqp29?entry=ttu"
//                 ></iframe>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;

import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Contact = () => {
  const API_BASE = 'http://localhost/api';
  
  const [contactData, setContactData] = useState({
    title: "Zapraszamy",
    contactTitle: "Kontakt",
    locations: [
      {
        name: "Kolorowe Domki",
        address: "ul. Wiatrakowa 30\n84-104 Jastrzębia Góra"
      },
      {
        name: "Apartamenty",
        address: "ul. Rydzowa 1\n84-104 Jastrzębia Góra - Tupadły"
      }
    ],
    phone: "+48 608 025 978",
    email: "kontakt@kolorowedomki.com",
    hours: "Cały tydzień 8:00-22:00",
    formTitle: "Wyślij zapytanie",
    consentText: "Wypełniając formularz i klikając przycisk „Wyślij\", wyrażasz zgodę na przesłanie Twojego zapytania, w tym Twoich danych osobowych. Administratorem Twoich danych osobowych jest <strong>Wynajem Domków Urszula Drużna, ul. Rydzowa 1, 84-104 Jastrzębia Góra, NIP: 5291267100 </strong>. Szczegóły w jaki sposób przetwarzamy Twoje dane oraz jakie prawa z tym związane znajdziesz w naszej <a href=\"/PolitykaPrywatnosci\" class=\"text-yellow-600 hover:text-yellow-700 underline\">Polityce Prywatności</a>.",
    mapsTitle: "Gdzie nas znajdziesz",
    maps: [
      {
        title: "Mapa: Kolorowe Domki",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2326.874366284683!2d18.3217428!3d54.8267214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fc4b29b9b7bebb%3A0x5b107c7de8090dc!2sKolorowe%20Domki%20Jastrz%C4%99bia%20G%C3%B3ra!5e0!3m2!1spl!2spl!4v1700000000000!5m2!1spl!2spl"
      },
      {
        title: "Mapa: Apartamenty Kolorowe Domki",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2326.856789012345!2d18.321132!3d54.825977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fc4b3498a3f99f%3A0xce86cb90a9dfbc7a!2sApartamenty%20Kolorowe%20Domki!5e0!3m2!1spl!2spl!4v1700000000000!5m2!1spl!2spl"
      }
    ]
  });

  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    phone: '',
    message: '',
    consent: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  // Załaduj dane kontaktowe z serwera
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/contact.php?t=${Date.now()}`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych kontaktowych');
        }
        
        const data = await response.json();
        setContactData(data);
      } catch (error) {
        console.error('Błąd ładowania danych kontaktowych:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();

    // Sprawdzaj zmiany co 10 sekund
    // const interval = setInterval(fetchContactData, 10000);
    // return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://kolorowedomki.com/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus({ type: 'success', message: 'Formularz został wysłany pomyślnie!' });
        // Reset form
        setFormData({
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
          consent: false
        });
      } else {
        setSubmitStatus({ type: 'error', message: result.message || 'Wystąpił błąd podczas wysyłania formularza' });
      }

    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Wystąpił błąd połączenia. Spróbuj ponownie.' });
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Funkcja do renderowania HTML z konsentText
  const renderConsentText = () => {
    return { __html: contactData.consentText || '' };
  };

  if (loading) {
    return (
      <section className="py-16 bg-[#edece8] relative">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-[#edece8] relative">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-yellow-600 text-left mb-8 md:mb-12 lg:mb-12 pr-4">
          {contactData.title || "Zapraszamy"}
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Left Section: Kontakt Info */}
          <div className="flex flex-col justify-center">
            <h2 className="text-3xl font-semibold mb-8 text-gray-800">
              {contactData.contactTitle || "Kontakt"}
            </h2>
            <div className="space-y-6">
              {/* Lokalizacje */}
              {contactData.locations && contactData.locations.map((location, index) => (
                <div key={index} className="flex items-start">
                  <FaMapMarkerAlt className="text-yellow-500 text-2xl mt-1 mr-4 flex-shrink-0" />
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      {location.name}
                    </h3>
                    <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-line">
                      {location.address}
                    </p>
                  </div>
                </div>
              ))}

              {/* Telefon */}
              <div className="flex items-center">
                <FaPhoneAlt className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
                <p className="text-lg text-gray-700">
                  <span className="font-semibold">Telefon:</span> {contactData.phone}
                </p>
              </div>

              {/* Email */}
              <div className="flex items-center">
                <FaEnvelope className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
                <p className="text-lg text-gray-700">
                  <span className="font-semibold">Email:</span>{' '}
                  <a href={`mailto:${contactData.email}`} className="text-yellow-600 hover:underline">
                    {contactData.email}
                  </a>
                </p>
              </div>

              {/* Godziny pracy */}
              <div className="flex items-center">
                <FaClock className="text-yellow-500 text-2xl mr-4 flex-shrink-0" />
                <p className="text-lg text-gray-700">
                  <span className="font-semibold">Godziny pracy:</span> {contactData.hours}
                </p>
              </div>
            </div>
          </div>

          {/* Right Section: Contact Form */}
          <div className="flex flex-col justify-center bg-white p-8 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">
              {contactData.formTitle || "Wyślij zapytanie"}
            </h3>
            
            {/* Status message */}
            {submitStatus && (
              <div className={`mb-4 p-3 rounded-lg ${
                submitStatus.type === 'success' 
                  ? 'bg-green-100 text-green-800 border border-green-200' 
                  : 'bg-red-100 text-red-800 border border-red-200'
              }`}>
                {submitStatus.message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Imię i Nazwisko */}
              <div className="mb-4 flex space-x-4">
                <div className="w-1/2">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">Imię *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
                    placeholder="Wpisz swoje imię"
                    required
                  />
                </div>
                <div className="w-1/2">
                  <label htmlFor="surname" className="block text-sm font-medium text-gray-700">Nazwisko</label>
                  <input
                    type="text"
                    id="surname"
                    name="surname"
                    value={formData.surname}
                    onChange={handleChange}
                    className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
                    placeholder="Wpisz swoje nazwisko"
                  />
                </div>
              </div>

              {/* Adres Email */}
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
                  placeholder="Wpisz swój email"
                  required
                />
              </div>

              {/* Telefon */}
              <div className="mb-4">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
                  placeholder="Wpisz swój numer telefonu"
                />
              </div>

              {/* Wiadomość */}
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700">Wiadomość *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full p-3 border-b-2 border-transparent focus:outline-none focus:border-yellow-500"
                  placeholder="Napisz swoją wiadomość"
                  required
                />
              </div>

              {/* Zgoda */}
              <div className="mb-6 flex items-start">
                <input 
                  type="checkbox" 
                  id="consent" 
                  name="consent" 
                  checked={formData.consent}
                  onChange={handleChange}
                  required 
                  className="mt-1 mr-2" 
                />
                <label htmlFor="consent" className="text-sm text-gray-700">
                  <span dangerouslySetInnerHTML={renderConsentText()} />
                </label>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-yellow-500 text-white py-3 rounded-full hover:bg-yellow-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-300 flex items-center justify-center"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Wysyłanie...
                  </>
                ) : (
                  'Wyślij'
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Mapy */}
        {contactData.maps && contactData.maps.length > 0 && (
          <div className="mt-12 px-4">
            <h2 className="text-3xl font-semibold mb-4">
              {contactData.mapsTitle || "Gdzie nas znajdziesz"}
            </h2>
            
            <div className="flex flex-col lg:flex-row lg:justify-center lg:space-x-8 space-y-12 lg:space-y-0">
              {contactData.maps.map((map, index) => (
                <div key={index} className="flex-1 flex flex-col items-center">
                  <h3 className="text-xl font-semibold mb-4 text-yellow-600">
                    {map.title}
                  </h3>
                  <div className="w-full max-w-[398px] aspect-[398/678]">
                    <iframe
                      title={map.title}
                      className="w-full h-full rounded-lg shadow-md"
                      style={{ border: 0 }}
                      loading="lazy"
                      allowFullScreen
                      src={map.url}
                    ></iframe>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Contact;